import EnvironmentContextInterface from './EnvironmentContextInterface';

const initialContextState: EnvironmentContextInterface = {
  REACT_APP_CLIENT_BASE_URL: undefined,
  REACT_APP_API_BASE_URL: undefined,
  REACT_APP_IDLE_TIMEOUT: 3600000,
  REACT_APP_LOGIN_TIMEOUT: 86400000,
  REACT_APP_PROMPT_TIMEOUT: 300000,
  REACT_APP_FILE_UPLOAD_URL: '',
  REACT_APP_FIREBASE_REDIRECT_URL: 'https://localhost:4200/',
  REACT_APP_GOOGLE_MAPS_API_KEY: '',
  REACT_APP_SPLUNK_TOKEN: '',
  REACT_APP_SPLUNK_URL: ''
};

export default initialContextState;
